import BankTransferIcon from "../components/IconComp/bankTransfer";
import CardPaymentIcon from "../components/IconComp/cardPaymentIcon";
import EasyPaisaIcon from "../components/IconComp/easyPaisaIcon";
import InClinicCashIcon from "../components/IconComp/inClinicCashIcon";
import JazzCashIcon from "../components/IconComp/jazzCashIcon";

export const ButtonTitles: any = {
  Reopen: {
    title: "Re Open",
  },
  Prescription: {
    //title: "Prescription(ctrl+p)",
    title: "Prescription",
  },
  Cancel: {
    title: "Cancel",
  },
  Completed: {
    title: "Completed",
  },
  History: {
    // title: "History(ctrl+h)",
    title: "History",
  },
  Admit: {
    title: "Admit",
  },
  Invoice: {
    //title: "Invoice(ctrl+i)",
    title: "Invoice",
  },
  Add: {
    title: "Add",
  },
  Edit: {
    title: "Edit",
  },
  Permissions: {
    title: "Permissions",
  },
  Call: {
    title: "Call",
  },
  True: {
    title: "Complete",
  },
  False: {
    title: "Cancel",
  },
};

export const drawerWidth = 256;

export const DashBoardCardColors = {
  Patient: {
    primary: "#00A1F1;",
    secondary: "#59C8FF",
  },
  Doctor: {
    primary: "#FEB702",
    secondary: "#FFDB7E",
  },
  Hospital: {
    primary: "#4681FA",
    secondary: "#87ADFA",
  },
  Revenue: {
    primary: "#00BB8C",
    secondary: "#1CD9A9",
  },
  Staff: {
    primary: "#8D7CFF",
    secondary: "#AB9FFC",
  },
  Appointments: {
    primary: "#fa9e6b",
    secondary: "#f7b997",
  },
  Clinic: {
    primary: "#ed7505",
    secondary: "#FF9838",
  },
};
export const DashBoardHeaderCardColors = {
  sale: {
    primary: "#D9FFF5",
    secondary: "#59C8FF",
  },
  revenue: {
    primary: "#FFF5DC",
    secondary: "#FFDB7E",
  },
  medAvailable: {
    primary: "#DEF4FF",
    secondary: "#87ADFA",
  },
  medShortage: {
    primary: "#FFFFFF",
    secondary: "#F0483E4D",
  },
  allProducts: {
    primary: "#EEEAFF",
    secondary: "#F0483E4D",
  },
  totalCost: {
    primary: "#F8931F4A",
    secondary: "#F0483E4D",
  },
};
export const PharmacyPackage = [
  { id: 2, description: "Revenue Record" },
  { id: 3, description: "Inventory Management" },
  { id: 4, description: "Staff Management" },
  { id: 5, description: "Sales Record" },
  { id: 6, description: "Shift Management" },
  { id: 7, description: "Suppliers Management" },
];
export enum InclinicPaymentType {
  JazzCash = 0,
  EasyPaisa = 1,
  BankCard = 2,
  Cash = 3,
  Other = 4,
  BankTransfer = 5,
}
export enum SubscriptionEnums {
  PENDING = 0,
  REJECT = 1,
  ACTIVE = 2,
  EXPIRED = 3,
  TERMINATE = 4,
  NOSUBSCRIPTION = 5,
}
export const BackGroundColor = {
  backgroundcolor: "#F0F1F5",
};

export const ButtonColor = {
  buttoncolor: "#C22249",
};
export const SideBarColor = {
  sidebarcolor: "#0B2238",
};
export const salesHistoryTableHeaderData = [
  { label: "Invoice Number", key: "Invoice Number" },
  { label: "Date", key: "Date" },
  { label: "Total Amt", key: "Total Amount(RS.)" },
  { label: "Discount (%)", key: "Discount(%)" },
  { label: "Discount Amt", key: "Discount Amount" },
  { label: "Total Payable", key: "Total Payable" },
  { label: "Paid", key: "Paid" },
];

export const stockHistoryTableHeaderData = [
  { label: "Invoice ID", key: "Invoice ID" },
  { label: "Supplier Name", key: "Supplier Name" },
  { label: "Product Name", key: "Product Name" },
  { label: "Qty", key: "Qty" },
  { label: "Rate", key: "Rate" },

  { label: "Discount (Amt)", key: "Discount (Amt)" },
  { label: "Sales Tax(Amt)", key: "Sales Tax(Amt)" },
  { label: "Amount", key: "Amount" },
];

export const CityList = [
  { name: "Islamabad" },

  {
    name: "Rawalpindi",
  },
  {
    name: "Lahore",
  },
  {
    name: "Gujrat",
  },
  {
    name: "Karachi",
  },
  {
    name: "Faisalabad",
  },
  {
    name: "Multan",
  },
  {
    name: "Sahiwal",
  },
  {
    name: "Peshawar",
  },
  {
    name: "Quetta",
  },
  {
    name: "Mianwali",
  },
  {
    name: "Jalal-pur-Jattan",
  },
  {
    name: "Sialkot",
  },
  {
    name: "Abbottabad",
  },
  {
    name: "Jhelum",
  },
  {
    name: "Muzaffarabad",
  },
  {
    name: "Rahim Yar Khan",
  },
  {
    name: "Okara",
  },
  {
    name: "Chiniot",
  },
  {
    name: "Dera Ghazi Khan",
  },
  {
    name: "Larkana",
  },
  {
    name: "Mingora",
  },
  {
    name: "Gwadar",
  },
  {
    name: "Mansehra",
  },
  {
    name: "Mirpur Khas",
  },
  {
    name: "Kotli",
  },
  {
    name: "Nowshera",
  },
  {
    name: "Attock",
  },
  {
    name: "Swabi",
  },
  {
    name: "Khairpur",
  },
  {
    name: "Vehari",
  },
  {
    name: "Sheikhupura",
  },
  {
    name: "Hafizabad",
  },
  {
    name: "Kasur",
  },
  {
    name: "Sadiqabad",
  },
  {
    name: "Mandi Bahauddin",
  },
  {
    name: "Narowal",
  },
  {
    name: "Jhang",
  },
  {
    name: "Kashmir",
  },
  {
    name: "Bhakkar",
  },
  {
    name: "Bahawalpur",
  },
  {
    name: "Barakahu",
  },
  {
    name: "Pakpattan",
  },
  {
    name: "Turbat",
  },
  {
    name: "Dera Ismail Khan",
  },
  {
    name: "Chitral",
  },
  {
    name: "Chakwal",
  },
  {
    name: "Khuzdar",
  },
  {
    name: "Haripur",
  },
  {
    name: "Kamalia",
  },
  {
    name: "Shikarpur",
  },
  {
    name: "Tando Allahyar",
  },
  {
    name: "Umerkot",
  },
  {
    name: "Khanewal",
  },
  {
    name: "Jacobabad",
  },
  {
    name: "Tando Muhammad Khan",
  },
  {
    name: "Charsadda",
  },
  {
    name: "Muzaffargarh",
  },
  {
    name: "Sahiwal",
  },
  {
    name: "Pattoki",
  },
  {
    name: "Jaranwala",
  },
  {
    name: "Kandhkot",
  },
  {
    name: "Toba Tek Singh",
  },
  {
    name: "Ghotki",
  },
  {
    name: "Nawabshah",
  },
  {
    name: "Bannu",
  },
  {
    name: "Kohat",
  },
  {
    name: "Sanghar",
  },
  {
    name: "Bhakkar",
  },
  {
    name: "Badin",
  },
  {
    name: "Matiari",
  },
  {
    name: "Mirpur Mathelo",
  },
  {
    name: "Zhob",
  },
  {
    name: "Hangu",
  },
  {
    name: "Kot Addu",
  },
  {
    name: "Daska",
  },
  {
    name: "Gojra",
  },
  {
    name: "Samundri",
  },
  {
    name: "Muridke",
  },
  {
    name: "Kabirwala",
  },
  {
    name: "Bhalwal",
  },
  {
    name: "Fateh Jang",
  },
  {
    name: "Kamra",
  },
  {
    name: "Kot Radha Kishan",
  },
  {
    name: "Phalia",
  },
  {
    name: "Hub",
  },
  {
    name: "Mehar",
  },
  {
    name: "Moro",
  },
  {
    name: "Ranipur",
  },
  {
    name: "Kharian",
  },
  {
    name: "Kundian",
  },
  {
    name: "Sehwan",
  },
  {
    name: "Sibi",
  },
  {
    name: "Tangi",
  },
  {
    name: "Chishtian",
  },
  {
    name: "Dadu",
  },
  {
    name: "Tando Adam",
  },
  {
    name: "Dipalpur",
  },
  {
    name: "Shahdadpur",
  },
  {
    name: "Shorkot",
  },
  {
    name: "Shahkot",
  },
  {
    name: "Khanpur",
  },
  {
    name: "Rajanpur",
  },
  {
    name: "Usta Muhammad",
  },
  {
    name: "Pishin",
  },
  {
    name: "Layyah",
  },
  {
    name: "Parachinar",
  },
  {
    name: "Upper Dir",
  },
  {
    name: "Lower Dir",
  },
  {
    name: "Alipur",
  },
  {
    name: "Turbat",
  },
  {
    name: "Khuzdar",
  },
  {
    name: "Kalabagh",
  },
  {
    name: "Daultala",
  },
  {
    name: "Taunsa",
  },
  {
    name: "Karak",
  },
  {
    name: "Kalat",
  },
  {
    name: "Kotli Loharan",
  },
  {
    name: "Tando Jam",
  },
  {
    name: "Hala",
  },
  {
    name: "Rohri",
  },
  {
    name: "Dinga",
  },
  {
    name: "Lodhran",
  },
];
export const SendOTP = [
  {
    id: "doctor",
    title: "Doctor",
  },
  {
    id: "clinic_owner",
    title: "Clinic",
  },
  {
    id: "patient",
    title: "Patient",
  },
];

export const units = [
  { id: 1, name: "Picogram (pg)" },
  { id: 2, name: "Nanogram (ng)" },
  { id: 3, name: "Microgram (mcg or µg)" },
  { id: 4, name: "Milligram (mg)" },
  { id: 5, name: "Gram (g)" },
  { id: 6, name: "Kilogram (kg)" },
  { id: 7, name: "Microliter (μL)" },
  { id: 8, name: "Milliliter (mL)" },
  { id: 9, name: "Centiliter (cL)" },
  { id: 10, name: "Liter (L)" },
  { id: 11, name: "Micrometer (µm)" },
  { id: 12, name: "Millimeter (mm)" },
  { id: 13, name: "Centimeter (cm)" },
  { id: 14, name: "Meter (m)" },
  { id: 15, name: "Millisecond (ms)" },
  { id: 16, name: "Second (s)" },
  { id: 17, name: "Minute (min)" },
  { id: 18, name: "Hour (h)" },
  { id: 19, name: "Day (d)" },
  { id: 20, name: "Celsius (°C)" },
  { id: 21, name: "Fahrenheit (°F)" },
  { id: 22, name: "Kelvin (K)" },
  { id: 23, name: "Millimeter of Mercury (mmHg)" },
  { id: 24, name: "Kilopascal (kPa)" },
  { id: 25, name: "Atmosphere (atm)" },
  { id: 26, name: "Percentage (%)" },
  { id: 27, name: "Parts per million (ppm)" },
  { id: 28, name: "Parts per billion (ppb)" },
  { id: 29, name: "Molarity (M)" },
  { id: 30, name: "Molality (m)" },
  { id: 31, name: "Milliequivalent (mEq)" },
  { id: 32, name: "Milligrams per deciliter (mg/dL)" },
  { id: 33, name: "Millimoles per liter (mmol/L)" },
  { id: 34, name: "Milliequivalent per liter (mEq/L)" },
];

export const BatchHeader = [
  { id: 1, title: "Batch No.", is_med: false },
  { id: 2, title: "Shelf No." },
  { id: 3, title: "Name", is_med: true },
  { id: 4, title: "Stock In" },
  { id: 5, title: "Stock Out" },
  { id: 6, title: "Stock Remaining" },
  { id: 7, title: "Sell Price" },
  { id: 8, title: "Cost Price" },
  { id: 9, title: "Total Cost" },
  { id: 10, title: "Production Date" },
  { id: 11, title: "Expire Date" },
  { id: 12, title: "Supplier Name" },
  { id: 13, title: "Supplier Invoice no." },
  { id: 14, title: "Actions" },
];

export const OrderPurchaseHeader = [
  {
    id: 1,
    title: "Medicine Name",
    // is_med: true
  },
  { id: 2, title: "Dose" },
  { id: 3, title: "Total Quantity" },
  { id: 4, title: "R. Quantity" },
  { id: 5, title: "Manufacturer Name" },
  { id: 6, title: "Actions" },
];

export const PolicyHeader = [
  { id: 1, title: "Policy Description" },
  { id: 2, title: "Actions" },
];

export const InstructionsHeader = [
  { id: 1, title: "Title" },
  { id: 2, title: "Description" },
  { id: 3, title: "Actions" },
];

export const PurchasesHeader = [
  { id: 1, title: "Batch No.", is_med: false },
  { id: 2, title: "Medicine Name", is_med: true },
  { id: 3, title: "Quantity" },
  { id: 10, title: "Rate" },
  { id: 11, title: "Total Amt" },
  { id: 4, title: "Extra Discount/Bonus" },
  { id: 5, title: "Purchase Date" },
  { id: 6, title: "Stock Cost Price" },
  { id: 11, title: "Sales Tax" },
  { id: 7, title: "Invoice ID" },
  { id: 8, title: "Expire Date" },
  { id: 9, title: "Supplier Name" },
  // { id: 9, title: "Actions" },
];

export const MedicalProductsHeader = [
  { id: 1, title: "Name" },
  { id: 2, title: "Formula" },
  { id: 3, title: "Dose" },
  { id: 4, title: "Total Quantity" },
  { id: 5, title: "Remaining Quantity" },
  { id: 6, title: "Generic Name" },
  { id: 7, title: "Category" },
  { id: 8, title: "Manufacturer Name" },
  { id: 9, title: "Actions" },
];
export const ProductSalesHistoryHeader = [
  { id: 1, title: "Product Name" },
  { id: 2, title: "Dose" },
  { id: 3, title: "Generic Name" },
  { id: 4, title: "Sold Quantity" },
];

export const saleTypeDropDownOptions = ["Unit", "Box"];

export const NonMedicalProductsHeader = [
  { id: 1, title: "Name" },
  { id: 2, title: "Brand Name" },
  { id: 3, title: "Category" },
  { id: 4, title: "Total Quantity" },
  { id: 5, title: "Remaining Quantity" },
  { id: 6, title: "Actions" },
];

export const SupplierHeader = [
  { id: 1, title: "Supplier Name/Company" },
  { id: 2, title: "Contact Person" },
  { id: 3, title: "Phone#" },
  { id: 4, title: "Email" },
  { id: 5, title: "Actions" },
];
export const CustomerHisHeader = [
  { id: 1, title: "Name" },
  { id: 2, title: "Phone#" },
  // { id: 3, title: "Email" },
  { id: 3, title: "Due Amount" },
  { id: 4, title: "Actions" },
];

export const SupplierDetailHeader = [
  { id: 1, title: "Batch No." },
  { id: 2, title: "Medicine Name" },
  { id: 3, title: "Qt. in box" },
  { id: 4, title: "Qt. in units" },
  { id: 5, title: "Total Qt." },
  { id: 6, title: "Remaining Qt." },
  { id: 7, title: "Sell price" },
  { id: 8, title: "Shelf No." },
  { id: 9, title: "Expiry date" },
];

export const PaymentHistoryHeader = [
  { id: 1, title: "Invoice No." },
  { id: 2, title: "Date" },
  { id: 3, title: "Total Amt" },
  { id: 4, title: "Dis(%)" },
  { id: 5, title: "Dis Amt" },
  { id: 6, title: "Total Payable" },
  { id: 7, title: "Paid" },
  { id: 8, title: "Due(s)" },
  { id: 9, title: "Actions" },
];

export const paymentMethods = [
  {
    value: "Card Payment",
    id: InclinicPaymentType.BankCard,
    icon: <CardPaymentIcon />,
  },
  {
    value: "Easy Paisa",
    id: InclinicPaymentType.EasyPaisa,
    icon: <EasyPaisaIcon />,
  },
  {
    value: "Jazz Cash",
    id: InclinicPaymentType.JazzCash,
    icon: <JazzCashIcon />,
  },
  {
    value: "Bank Transfer",
    id: InclinicPaymentType.BankTransfer,
    icon: <BankTransferIcon />,
  },
  {
    value: "Cash",
    id: InclinicPaymentType.Cash,
    icon: <InClinicCashIcon />,
  },
];

export const CategoryHeader = [
  { id: 1, title: "Category Name" },
  { id: 2, title: "Type" },
  { id: 3, title: "Actions" },
];

export const MedicineFormulaHeader = [
  { id: 1, title: "Medicine Formula Name" },
  { id: 2, title: "Description" },
];

export const ManufacturerHeader = [{ id: 1, title: "Manufacturer Name" }];

export const stepsList = ["Add Staff", "Assign Pin", "User Permissions"];
export enum PharmacySuperCategory {
  MEDICAL = 0,
  NONMEDICAL = 1,
}

export const initialDropdownValues = {
  dropdown1: null,
  dropdown2: null,
  dropdown3: null,
  dropdown4: null,
  date: undefined,
};

export enum Roles {
  PHARMACIST = 0,
  TECHNICIAN = 1,
  ASSISTANT = 2,
  MANAGER = 3,
  INTERN = 4,
  STOCK_MANAGER = 5,
  CASHIER = 6,
}
export enum ShiftTypes {
  MORNING = 0,
  EVENING = 1,
  NIGHT = 2,
}
export const days = [
  { title: "Monday" },
  { title: "Tuesday" },
  { title: "Wednesday" },
  { title: "Thursday" },
  { title: "Friday" },
  { title: "Saturday" },
  { title: "Sunday" },
];

export const headerData = ["Item(s)", "QTY", "Price", "Amt"];

export const CategoryHeaderData = ["Category Name", "Description", "Actions"];

export const ShelfHeaderData = ["Name", "Total Batches", "Actions"];

export const BatchShelfHeaderData = [
  "Batch no.",
  "Medicine Name",
  "Remaining Qty",
  "Production Date",
  "Supplier Name",
];

export const BatchShelfInnerData = [
  {
    id: 1,
    Batch: "75442",
    MedicineName: "Caflam",
    RemainingQty: "1200",
    ProductionDate: "23-03-24",
    SupplierName: "Supplier 1",
  },
  {
    id: 2,
    Batch: "55443",
    MedicineName: "Risek",
    RemainingQty: "1200",
    ProductionDate: "23-03-24",
    SupplierName: "Supplier 1",
  },
  {
    id: 3,
    Batch: "25444",
    MedicineName: "Syrup",
    RemainingQty: "1200",
    ProductionDate: "23-03-24",
    SupplierName: "Supplier 1",
  },
  {
    id: 4,
    Batch: "55445",
    MedicineName: "Caflum",
    RemainingQty: "1200",
    ProductionDate: "23-03-24",
    SupplierName: "Supplier 1",
  },
  {
    id: 5,
    Batch: "53446",
    MedicineName: "Risek",
    RemainingQty: "1200",
    ProductionDate: "23-03-24",
    SupplierName: "Supplier 1",
  },
  {
    id: 6,
    Batch: "75447",
    MedicineName: "Tylenol",
    RemainingQty: "1200",
    ProductionDate: "23-03-24",
    SupplierName: "Supplier 1",
  },
  {
    id: 7,
    Batch: "85448",
    MedicineName: "Panedol",
    RemainingQty: "1200",
    ProductionDate: "23-03-24",
    SupplierName: "Supplier 1",
  },
  {
    id: 8,
    Batch: "55449",
    MedicineName: "Risek",
    RemainingQty: "1200",
    ProductionDate: "23-03-24",
    SupplierName: "Supplier 1",
  },
  {
    id: 9,
    Batch: "55450",
    MedicineName: "Caflam",
    RemainingQty: "1200",
    ProductionDate: "23-03-24",
    SupplierName: "Supplier 1",
  },
  {
    id: 10,
    Batch: "25451",
    MedicineName: "Flagyl",
    RemainingQty: "1200",
    ProductionDate: "23-03-24",
    SupplierName: "Supplier 1",
  },
  {
    id: 11,
    Batch: "25451",
    MedicineName: "Flagyl",
    RemainingQty: "1200",
    ProductionDate: "23-03-24",
    SupplierName: "Supplier 1",
  },
  {
    id: 12,
    Batch: "25451",
    MedicineName: "Flagyl",
    RemainingQty: "1200",
    ProductionDate: "23-03-24",
    SupplierName: "Supplier 1",
  },
  {
    id: 13,
    Batch: "25451",
    MedicineName: "Flagyl",
    RemainingQty: "1200",
    ProductionDate: "23-03-24",
    SupplierName: "Supplier 1",
  },
];

export const expenseHeaderData = [
  "Date",
  "Name",
  "Expense Category",
  "Expense Amount",
  "Actions",
];
export const ProductHeaders = [
  { id: 1, title: "Product Name" },
  { id: 2, title: "Batch no." },
  { id: 3, title: "Qt in Box" },
  { id: 4, title: "Qt in Units" },
  { id: 12, title: "Total Quantity" },
  { id: 5, title: "Cost Price" },
  { id: 6, title: "Rate/Sell Price" },
  { id: 7, title: "Amount" },
  { id: 8, title: "Discount(%)" },
  { id: 9, title: "Discount" },
  { id: 10, title: "Payable Amt" },
  { id: 11, title: "Actions" },
];

export const SupplierBatchesHeaders = [
  { id: 1, title: "Batch No." },
  { id: 2, title: "Medicine Name" },
  { id: 3, title: "Qt. in box" },
  { id: 4, title: "Qt. in units" },
  { id: 12, title: "Total St." },
  { id: 5, title: "Sell price" },
  { id: 6, title: "Cost price" },
  { id: 7, title: "Shelf No." },
  { id: 8, title: "Expiry date" },

  { id: 9, title: "Actions" },
];

export const BatchListHeaders = [
  { id: 1, title: "Batch No." },
  { id: 2, title: "Total Boxes" },
  { id: 3, title: "Unit per Box" },
  { id: 4, title: "Total Qt." },
  { id: 5, title: "Remaining Qt." },
  { id: 6, title: "Sell price" },
  { id: 7, title: "Shelf Name" },
  { id: 8, title: "Expiry Date" },
];
export const MedBatchHeaders = [
  { id: 1, title: "Medicine Name" },
  { id: 2, title: "Total Quantity" },
  { id: 3, title: "Remaining Quantity" },
];
export const RestockProductBatchHeaders = [
  { id: 1, title: "Batch No." },
  { id: 2, title: "Total boxes" },
  { id: 3, title: "Units per box" },
  { id: 4, title: "Total Qt." },
  { id: 5, title: "Cost price" },
  { id: 6, title: "Sell price" },
  { id: 7, title: "Shelf No." },
  { id: 8, title: "Exp. Date" },
  { id: 9, title: "Actions" },
];
export const RestockProductHeader = [
  { id: 1, title: "Medicine Name" },
  { id: 2, title: "Total Quantity" },
  { id: 3, title: "Remaining Quantity" },
];

export const ProductReturnHeader = [
  { id: 1, title: "Batch no." },
  { id: 2, title: "Name" },
  { id: 3, title: "Quantity Sold" },
  { id: 4, title: "Quantity Returned" },
  { id: 5, title: "Rate/Sell Price" },
  { id: 6, title: "Amount" },
  { id: 7, title: "Action" },
];
